<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مقدم الطلب:</label>
            <div>{{ dataRow.User ? dataRow.User.name : '-' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع الطلب:</label>
            <div>{{ (dataRow.isFree)? 'مجاني' : 'غير مجاني' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الصك / العقار / السجل العيني:</label>
            <div>{{ dataRow.deedNumber }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع الاعلان:</label>
            <div>{{ adTypeChoices[dataRow.adType] }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم هوية المالك/الوكيل:</label>
            <div>{{ dataRow.identityNumber }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ ميلاد المالك/الوكيل:</label>
            <div class="date-format">{{ dataRow.birthDate }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم جوال المالك/الوكيل:</label>
            <div>{{ dataRow.mobile }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">سعر العقار:</label>
            <div>{{ dataRow.price }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الطلب:</label>
            <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مصدر الطلب:</label>
              <div>
                <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
                <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
                <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
                <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
                <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
                <span v-else class="text-muted">غير محدد</span>
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الطلب:</label>
            <select v-model="status" class="form-control">
              <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">قيمة الخدمة:</label>
            <div>{{ dataRow.servicePrice }} {{ (dataRow.isPaid)? 'مدفوع' : 'غير مدفوع' }}</div>
            <div v-if="dataRow.couponAccepted">
              <div><strong>لديه كوبون خصم</strong></div>
              <div>السعر بعد الخصم: {{ dataRow.priceAfterDiscount }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">ملاحظات الإدارة:</label>
            <textarea v-model="adminNote" class="form-control" rows="3"></textarea>
          </div>
        </div>

        <div v-if="dataRow.attachments && dataRow.attachments.length" class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">صورة الصك / المرفقات:</label>
            <div v-for="(f, indx) in dataRow.attachments" :key="indx">
              <a :href="`${BASE_URL}uploads/${f}`" target="_blank">{{ f }}</a>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'AdLicenseReqForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
    adTypeObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      adTypeChoices: {},
      status: 'new',
      adminNote: '',
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods: {
    formatDate,
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/adLicenseReq/update/${this.dataRow.id}`, {
          status: this.status,
          adminNote: this.adminNote,
        });
      else
        return false;

      api.then(({data}) => {
        this.message = 'تم التعديل بنجاح';
        this.hasSucess = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
      this.adminNote = this.dataRow.adminNote;
    }
    this.statusChoices = this.statusObject;
    this.adTypeChoices = this.adTypeObject;
  }
}
</script>
